import React from "react";
import ReactDOM from "react-dom";
// Apply Redux
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import thunk from 'redux-thunk'; // for using API data and pass it to reducers
import reducers from "./reducers";

import "semantic-ui-css/semantic.min.css";
import "./index.css";
import App from "./components/App";

ReactDOM.render(
    <Provider store={createStore(reducers, applyMiddleware(thunk))}>
        <App />
    </Provider>
    , document.getElementById("root"));
